import * as API from '../api/CityGuidesApi';

export function getGuides() {
  return API.getGuides();
}

export function putGuide(guide) {
  return API.putGuide(guide);
}

export function deleteGuide(guideId) {
  return API.deleteGuide(guideId);
}

export function getEntertainmments() {
  return API.getEntertainments();
}

export function putEntertainment(entertainment) {
  return API.putEntertainment(entertainment);
}

export function deleteEntertainment(entertainmentId) {
  return API.deleteEntertainment(entertainmentId);
}

export function getUrlForImage(type, id) {
  const res = id ? API.getUrlForImageById(type, id) : API.getUrlForImage(type);
  return res;
}
